import React from 'react';

import { number, shape, string } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './TableData.scss';

export default class TableData extends BaseComponent {
  render() {
    const { rowSpan, colSpan, style, id, className, children } = this.props;

    const classNames = ClassNames(['TableData', className]);

    return (
      <td
        rowSpan={rowSpan}
        colSpan={colSpan}
        style={style}
        id={id}
        className={classNames}
      >
        {children}
      </td>
    );
  }
}

TableData.propTypes = {
  rowSpan: number,
  colSpan: number,
  style: shape({}),
  id: string,
  className: string
};

TableData.defaultProps = {
  rowSpan: 1,
  colSpan: 1,
  style: {},
  id: undefined,
  className: undefined
};
